import Vue from "vue";
import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import Feedback from "@Scripts/Components/Feedback/Feedback.vue";
import OfflineMenu from "@Scripts/Components/Offline/OfflineMenu.vue";
import OfflineStatus from "@Scripts/Components/Offline/OfflineStatus.vue";
import SearchBox from "@Scripts/Components/Search/SearchBox.vue";
import EmbedManager from "@Scripts/Components/EmbedManager/EmbedManager.vue";

import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-cookietoast", CookieToast);
        Vue.component("app-feedback", Feedback);
        Vue.component("app-offlinemenu", OfflineMenu);
        Vue.component("app-offlinestatus", OfflineStatus);
        Vue.component("app-searchbox", SearchBox);
        Vue.component("app-embedmanager", EmbedManager);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
    }
}